module.exports = __webpack_public_path__ + "assets/img/g1.1662b473.jpg";